import { createAsyncThunk } from "@reduxjs/toolkit";

import { conditionRuleset } from "./helpers/conditionRuleset";

import { payloadCreatorForSize } from "./requestSize";

export const requestSizeUpdate = createAsyncThunk(
  "thunks/requestSizeUpdate",
  payloadCreatorForSize,
  conditionRuleset
);
